import { NgModule } from '@angular/core'
import { ExperimentationWidgetComponent } from './experimentation-widget/experimentation-widget.component'
import { ViewAsWidgetComponent } from './view-as-widget/view-as-widget.component'
import { ExperimentationService } from './experimentation.service'
import { FloFlaggerService } from './floflagger.service'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { FloModalModule } from '../modal/modal.module'

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FloModalModule],
  declarations: [ExperimentationWidgetComponent, ViewAsWidgetComponent],
  exports: [ExperimentationWidgetComponent, ViewAsWidgetComponent],
  providers: [FloFlaggerService, { provide: ExperimentationService, useClass: FloFlaggerService }]
})
export class FloExperimentationModule {}
